import React, { Component } from "react";

import {
  CBreadcrumb,
  CBreadcrumbItem,
  CButton,
  CCol,
  CLink,
  CRow
} from "@coreui/react";
import PropTypes from "prop-types";
import { CiCalendar, CiMail, CiPhone } from "react-icons/ci";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setLayout } from "../../../actions/layoutActions";
import { setObj } from "../../../actions/noteActions";
import EvaluationBankDashboardItem from "../../../components/EvaluationBankDashboardItem/EvaluationBankDashboardItem";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import { TrailDashBoardItem } from "../../../components/TrailDashboardItem";
import URL from "../../../config/api";
import "./styles.css";
import axios from "../../../config/axios";

const SummaryContentItem = () => (
  <div className="summary-content-item-container">
    <h1>Teste</h1>
  </div>
);

class ProfileSummaryStudent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      trails: undefined,
      user_id: this.props.match.params.id,
      userData: undefined
      // evaluations: undefined
    };
  }

  componentDidMount() {
    (async () => {
      await axios
        .get(
          `${URL.api}activity/trail/userProgressListById/${this.state.user_id}?is_partial_progression=true`,
          {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          }
        )
        .then(resp => this.setState({ trails: resp.data.data }));
      // await axios
      //   .get(
      //     `${URL.api}activity/allocations/listByUser/${this.state.user_id}`,
      //     {
      //       headers: { Authorization: `Bearer ${this.props.user.token}` }
      //     }
      //   )
      //   .then(resp => {
      //     this.setState({ evaluations: resp.data.data });
      //   });
      await axios
        .get(`${URL.api}access/user/singleView/${this.state.user_id}`, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp =>
          this.setState({ userData: resp.data.data, loading: false })
        );
    })();
  }

  render() {
    return (
      <div className="summary-student-main-content">
        {this.state.loading ? (
          <Loading />
        ) : (
          <>
            <CBreadcrumb className="w-100 p-0 border-0">
              <CBreadcrumbItem>
                <CLink to="/dashboard">Menu Inicial</CLink>
              </CBreadcrumbItem>
              <CBreadcrumbItem active>
                <span>Estatísticas do Estudante</span>
              </CBreadcrumbItem>
            </CBreadcrumb>
            <CRow className="summary-student-header-content">
              <CCol
                md="2"
                sm="12"
                className="d-flex justify-content-center align-items-center"
              >
                <img
                  src={`${URL.img}${
                    this.state.userData.user.photo ||
                    "uploads/users/profileEmpty.jpg"
                  }`}
                  className="summary-student-pic"
                />
              </CCol>
              <CCol sm="10">
                <CRow className="d-flex flex-column">
                  <h2 className="summary-student-header-name">
                    {this.state.userData.user.name || "Não informado"}
                  </h2>
                  <h3 className="summary-student-header-email">
                    {this.state.userData.user.username || "Não informado"}
                  </h3>
                </CRow>
                <CRow className="mt-3">
                  <CCol
                    md="3"
                    sm="12"
                    className="p-0 d-flex align-items-center"
                  >
                    <h4 className="summary-student-header-item-content">
                      <CiCalendar
                        size={22}
                        color="#4D65A680"
                        className="mr-2"
                      />
                      {this.state.userData.user_complement.birthday ||
                        "Não informado"}
                    </h4>
                  </CCol>
                  <CCol
                    md="3"
                    sm="12"
                    className="p-0 d-flex align-items-center"
                  >
                    <h4 className="summary-student-header-item-content">
                      <CiPhone size={22} color="#4D65A680" className="mr-2" />
                      {this.state.userData.user.phone || "Não informado"}
                    </h4>
                  </CCol>
                  <CCol
                    md="6"
                    sm="12"
                    className="p-0 d-flex align-items-center"
                  >
                    <h4 className="summary-student-header-item-content">
                      <CiMail size={22} color="#4D65A680" className="mr-2" />
                      {this.state.userData.user.email || "Não informado"}
                    </h4>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <div className="summary-section mt-5">
              <CRow className="w-100">
                <h2 className="summary-student-section-title">
                  Trilhas do usuário
                </h2>
                {this.props.user.user_roles[0].role_id !== 6 && (
                  <CButton
                    color="primary"
                    className="d-flex align-items-center p-2 cursor-pointer"
                    onClick={() =>
                      this.props.history.push(
                        `/partialprogression/allocateByUser/${this.state.user_id}`
                      )
                    }
                  >
                    <CiCalendar size={24} className="mr-2" /> Alocar progressão
                    parcial
                  </CButton>
                )}
              </CRow>
              <CRow>
                {this.state.trails?.length ? (
                  <>
                    {this.state.trails?.map((trail, index) => (
                      <CCol md="6" sm="12">
                        <TrailDashBoardItem
                          key={index}
                          title={trail.name}
                          image={trail.image}
                          progress={trail.progress}
                          currentStepTitle={trail.current_step_name}
                          currentStepId={trail.current_step_id}
                          trailAllocationId={trail.trail_allocation_id}
                          admin
                        />
                      </CCol>
                    ))}
                  </>
                ) : (
                  <div className="d-flex w-100 align-items-center justify-content-center mt-5">
                    Nenhuma trilha encontrada.
                  </div>
                )}
              </CRow>
            </div>
            <hr />
            {/* <div className="summary-section mt-5">
              <h2 className="summary-student-section-title">Avaliações</h2>
              <CRow>
                {this.state.evaluations?.length ? (
                  <>
                    {this.state.evaluations?.map((evaluation, index) => (
                      <CCol md="6" sm="12">
                        <EvaluationBankDashboardItem
                          key={index}
                          title={evaluation.name}
                          activityId={evaluation.activity_id}
                          infoUser={this.state.infoUser}
                          progress={
                            evaluation.completion_percentage
                              ? evaluation.completion_percentage
                              : 0
                          }
                        />
                      </CCol>
                    ))}
                  </>
                ) : (
                  <div className="d-flex w-100 align-items-center justify-content-center mt-5">
                    Nenhuma avaliação encontrada.
                  </div>
                )}
              </CRow>
            </div> */}
            <ProtectedRoute routeId={this.props.currentRoute} />
          </>
        )}
      </div>
    );
  }
}

ProfileSummaryStudent.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

ProfileSummaryStudent.defaultProps = {
  hideLayout: false,
  guestLogin: false
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj,
      setLayout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileSummaryStudent);
